import { jsx as _jsx } from "react/jsx-runtime";
import { useDomain } from '../../hooks/useDomain';
export const MemberBannerPlaceholder = ({ member, placeholderBanners: banners, }) => {
    var _a, _b;
    const { subfolder } = useDomain();
    if (!banners || banners.length === 0)
        return null;
    let index = 0;
    if (member === null || member === void 0 ? void 0 : member.id) {
        index = ((_a = member === null || member === void 0 ? void 0 : member.id) === null || _a === void 0 ? void 0 : _a.charCodeAt(((_b = member === null || member === void 0 ? void 0 : member.id) === null || _b === void 0 ? void 0 : _b.length) - 1)) % banners.length;
    }
    return _jsx("img", { src: `${subfolder}${banners[index]}`, alt: member === null || member === void 0 ? void 0 : member.name }, void 0);
};
//# sourceMappingURL=MemberBannerPlaceholder.js.map